var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessloss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2044_4682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.11141 3.09814C0.501329 3.09814 0.00265503 3.59682 0.00265503 4.20159V24.8859C0.00265503 25.496 0.501329 25.9947 1.11141 25.9947C1.66313 25.9947 2.16181 25.496 2.22016 24.8859V4.20159C2.21486 3.59682 1.71618 3.09814 1.11141 3.09814Z",
    fill: "#6AA13C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02652 8.90717C6.41644 8.90717 5.91777 9.40584 5.91777 10.0159V24.8913C5.91777 25.5013 6.41644 26 7.02652 26C7.6366 26 8.13528 25.5013 8.13528 24.8913V10.0106C8.13528 9.40053 7.6366 8.90717 7.02652 8.90717Z",
    fill: "#6AA13C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 12.8329C12.3902 12.8329 11.8915 13.3316 11.8915 13.9416V24.8912C11.8915 25.5013 12.3902 26 13.0003 26C13.6104 26 14.109 25.5013 14.109 24.8912V13.9363C14.109 13.3316 13.6104 12.8329 13.0003 12.8329Z",
    fill: "#6AA13C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9739 16.9231C18.3638 16.9231 17.8652 17.4218 17.8652 18.0318V24.8913C17.8652 25.5013 18.3638 26 18.9739 26C19.584 26 20.0243 25.5013 20.0827 24.8913V18.0318C20.0774 17.4218 19.584 16.9231 18.9739 16.9231Z",
    fill: "#6AA13C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8889 20.9071C24.2789 20.9071 23.7802 21.4058 23.7802 22.0159V24.8912C23.7802 25.5013 24.2789 25.9999 24.8889 25.9999C25.499 25.9999 25.9977 25.5013 25.9977 24.8912V22.0159C25.9977 21.4058 25.499 20.9071 24.8889 20.9071Z",
    fill: "#6AA13C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4615 13.496L19.6419 12.7215C19.0902 12.4456 18.427 12.7215 18.2042 13.2732C17.9284 13.8249 18.2042 14.4881 18.756 14.7109L23.9018 16.9231C24.5491 17.2361 25.2069 16.8859 25.3926 15.9841L25.9443 10.3979C25.9973 9.84615 25.557 9.28913 24.9469 9.23607C24.3952 9.18302 23.8382 9.62334 23.7851 10.2334L23.5464 12.7374C15.5093 0.56764 3.57824 0 3.04243 0C2.98938 0 2.98938 0 2.98938 0C2.3793 0 1.88063 0.440318 1.88063 1.0504C1.88063 1.66048 2.32095 2.15915 2.93103 2.15915C3.03713 2.15915 14.0186 2.71618 21.4615 13.496Z",
    fill: "#6AA13C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2044_4682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessloss);
export default __webpack_public_path__ + "static/media/processloss.15de2b34d6b9ffa34454ca9821258684.svg";
export { ForwardRef as ReactComponent };